<div class="modal-overlay">
  <div class="modal-container">
    <!-- Header -->
    <div class="modal-header">
      <div class="header-content">
        <h1 class="modal-title">{{ isEditMode ? 'Edit Fleet' : 'Add Fleet' }}</h1>
        <button class="close-button" (click)="onClose()" aria-label="Close modal">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M1 1L11 11M1 11L11 1"
              stroke="#555963"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Form Content -->
    <div class="form-content">
      <div class="form-top-spacing"></div>

      <div class="business-name-status-row">
        <!-- Business Name -->
        <div class="form-field">
          <label class="field-label">Business Name<span class="asterisk">*</span></label>
          <div class="input-wrapper">
            <input
              type="text"
              class="form-input"
              placeholder="Enter business name"
              pattern="[A-Za-z\s]*"
              [value]="formData().client"
              maxlength="100"
              (input)="onClientInput($event)"
              (keydown)="onClientKeydown($event)"
            />
          </div>
          <div *ngIf="clientNameError()" class="error-message">
            {{ clientNameError() }}
          </div>
        </div>

        <!-- Status -->
        <div class="form-field status-field">
          <label class="field-label" id="fleet-status-label">Status</label>
          <div class="status-toggle">
            <label class="switch">
              <input
                type="checkbox"
                aria-labelledby="fleet-status-label"
                [checked]="formData().status === 'active'"
                (change)="onStatusToggle($any($event.target).checked)"
              />
              <span class="slider round"></span>
            </label>
            <span class="status-label">{{
              formData().status === 'active' ? 'Active' : 'Inactive'
            }}</span>
          </div>
        </div>
      </div>

      <!-- Contact Number -->
      <div class="form-field">
        <label class="field-label">Contact Number<span class="asterisk">*</span></label>
        <div class="input-wrapper">
          <input
            type="tel"
            class="form-input"
            [class.error]="contactNumberError()"
            placeholder="5595550142"
            inputmode="numeric"
            [attr.maxlength]="contactPhoneMaxLength"
            [value]="formData().contactNumber"
            (input)="onContactNumberInput($event)"
          />
          <div *ngIf="contactNumberError()" class="field-error">
            {{ contactNumberError() }}
          </div>
        </div>
      </div>

      <!-- Email Address -->
      <div class="form-field">
        <label class="field-label">Email Address<span class="asterisk">*</span></label>
        <div class="input-wrapper">
          <input
            type="email"
            class="form-input"
            [class.error]="emailError()"
            placeholder="fleet@business.com"
            [value]="formData().email"
            (input)="onEmailInput($event)"
          />
          <div *ngIf="emailError()" class="field-error">
            {{ emailError() }}
          </div>
        </div>
      </div>

      <!-- Location -->
      <div class="form-field">
        <label class="field-label" id="fleet-location-label"
          >Location<span class="asterisk">*</span></label
        >
        <app-checkbox-multi-dropdown
          appearance="input"
          ariaLabel="Location"
          ariaLabelledBy="fleet-location-label"
          placeholder="Select location"
          [multipleSelectionText]="'{{count}} locations'"
          [options]="locationCheckboxOptions()"
          [selectedIds]="formData().locationIds"
          [showFooter]="false"
          [showAllOption]="true"
          [selectAllEmitsIds]="true"
          [fixedOverlay]="true"
          [loading]="loadingLocations()"
          [emptyMessage]="loadingLocations() ? 'Loading locations...' : 'No locations available'"
          (selectedIdsChange)="onLocationIdsChange($event)"
        ></app-checkbox-multi-dropdown>
      </div>

      <!-- Package -->
      <div class="form-field">
        <label class="field-label" id="fleet-package-label"
          >Package<span class="asterisk">*</span></label
        >
        <mat-select
          class="form-select"
          aria-labelledby="fleet-package-label"
          [placeholder]="packagePlaceholder()"
          [ngModel]="formData().packageId || ''"
          (ngModelChange)="onPackageIdChange($event)"
          [disabled]="formData().locationIds.length === 0 || loadingPackages()"
        >
          <mat-option *ngFor="let package of packages(); trackBy: trackById" [value]="package.id">
            {{ packageOptionLabel(package) }}
          </mat-option>
          <mat-option *ngIf="loadingPackages()" disabled value="">Loading packages...</mat-option>
          <mat-option
            *ngIf="!loadingPackages() && formData().locationIds.length === 0"
            disabled
            value=""
          >
            Select locations first
          </mat-option>
          <mat-option
            *ngIf="
              !loadingPackages() && formData().locationIds.length > 0 && packages().length === 0
            "
            disabled
            value=""
          >
            No common packages offered at selected locations
          </mat-option>
        </mat-select>
      </div>

      <!-- Pricing Type -->
      <div class="form-field">
        <label class="field-label" id="fleet-pricing-type-label"
          >Pricing Type<span class="asterisk">*</span></label
        >
        <mat-radio-group
          class="radio-button-group"
          aria-labelledby="fleet-pricing-type-label"
          name="pricingType"
          [ngModel]="formData().pricingType"
          (ngModelChange)="onPricingTypeChange($event)"
        >
          <div
            class="radio-option"
            *ngFor="let option of pricingTypeOptions; trackBy: trackByValue"
          >
            <mat-radio-button
              [value]="option.value"
              [id]="'fleet_pricing_type_' + option.value"
              [disabled]="pricingTypeLocked()"
            ></mat-radio-button>
            <label [for]="'fleet_pricing_type_' + option.value + '-input'">{{
              option.label
            }}</label>
          </div>
        </mat-radio-group>
        <div class="field-hint">{{ pricingTypeHint() }}</div>
        <div class="field-hint" *ngIf="pricingTypeLocked()">
          Pricing type can't be changed after the first fleet wash.
        </div>
      </div>

      <!-- Price -->
      <div class="form-field">
        <label class="field-label">Charged Price<span class="asterisk">*</span></label>
        <div class="input-wrapper">
          <input
            type="number"
            class="form-input"
            [class.error]="formData().pricePerVehicle === 0 || pricePerVehicleError()"
            placeholder="Add price"
            min="0"
            max="10000"
            step="1"
            [value]="formData().pricePerVehicle"
            (input)="onPriceInput($event)"
            (keydown)="onPriceKeydown($event)"
          />
          <div
            *ngIf="formData().pricePerVehicle === 0 || pricePerVehicleError()"
            class="field-error"
          >
            {{ pricePerVehicleError() || 'Charged price must be greater than 0' }}
          </div>
        </div>
        <div class="field-hint">The amount charged based on the selected pricing model.</div>
        <div class="field-hint" *ngIf="pendingPriceHint() && !deferredPriceChange()">
          {{ pendingPriceHint() }}
        </div>
        <div
          class="field-hint"
          *ngIf="deferredPriceChange() && formData().pricingType === 'per_vehicle'"
        >
          New price takes effect from the next billing cycle on
          {{ formatHintDate(nextCycleStartDate()) }}.
        </div>
        <ng-container *ngIf="deferredPriceChange() && formData().pricingType === 'per_wash'">
          <label class="field-label price-effective-label" id="fleet-price-effective-label"
            >Apply new price<span class="asterisk">*</span></label
          >
          <mat-radio-group
            class="radio-button-group"
            aria-labelledby="fleet-price-effective-label"
            name="priceEffective"
            [ngModel]="formData().priceEffective"
            (ngModelChange)="onPriceEffectiveChange($event)"
          >
            <div class="radio-option">
              <mat-radio-button
                value="next_wash"
                id="fleet_price_effective_next_wash"
              ></mat-radio-button>
              <label for="fleet_price_effective_next_wash-input">From next wash</label>
            </div>
            <div class="radio-option">
              <mat-radio-button
                value="next_cycle"
                id="fleet_price_effective_next_cycle"
              ></mat-radio-button>
              <label for="fleet_price_effective_next_cycle-input"
                >From next billing cycle ({{ formatHintDate(nextCycleStartDate()) }})</label
              >
            </div>
          </mat-radio-group>
        </ng-container>
      </div>

      <!-- Billing Cycle -->
      <div class="form-field">
        <label class="field-label">Billing Cycle<span class="asterisk">*</span></label>
        <div class="form-row">
          <div class="form-group">
            <label id="fleet-start-date-label" class="sr-only">Start date</label>
            <app-custom-date-picker
              aria-labelledby="fleet-start-date-label"
              placeholder="Start date"
              mode="date"
              [showTime]="false"
              [fixedOverlay]="true"
              [disabled]="isEditMode"
              [ngModel]="parsedStartDate()"
              (dateTimeChange)="onStartDateChange($event)"
            ></app-custom-date-picker>
          </div>

          <div class="form-group">
            <label id="fleet-billing-frequency-label" class="sr-only">Billing frequency</label>
            <mat-select
              class="form-select"
              aria-labelledby="fleet-billing-frequency-label"
              [ngModel]="formData().billingCycleType"
              (ngModelChange)="onBillingCycleChange($event)"
            >
              <mat-option
                *ngFor="let freq of billingCycleFrequencies; trackBy: trackByValue"
                [value]="freq.value"
              >
                {{ freq.label }}
              </mat-option>
            </mat-select>
          </div>
        </div>

        <div class="field-hint" *ngIf="isEditMode">
          Start date can't be changed after the fleet is created.
        </div>
        <div class="field-hint" *ngIf="formData().startDate && !isEditMode">
          First invoice on {{ formatHintDate(firstInvoiceDate()) }}. Charged after the
          {{ billingCycleLabel(formData().billingCycleType).toLowerCase() }}
          cycle closes; nothing is collected today.
        </div>
      </div>

      <!-- Vehicle Count -->
      <div class="form-field">
        <label class="field-label">Vehicle Count<span class="asterisk">*</span></label>
        <div class="input-wrapper">
          <input
            type="number"
            class="form-input"
            [class.error]="formData().vehicleCount === 0 || vehicleCountError()"
            placeholder="Number of cars coming in"
            min="0"
            [value]="formData().vehicleCount"
            (input)="onVehicleCountInput($event)"
          />
          <div *ngIf="formData().vehicleCount === 0 || vehicleCountError()" class="field-error">
            {{ vehicleCountError() || 'Vehicle count must be greater than 0' }}
          </div>
        </div>
        <div class="field-hint">Expected number of cars to arrive</div>
      </div>

      <!-- Duration -->
      <div class="form-field">
        <label class="field-label" id="fleet-expiry-label">Duration</label>
        <mat-select
          class="form-select"
          aria-labelledby="fleet-expiry-label"
          [ngModel]="formData().expiryMonths"
          (ngModelChange)="onExpiryChange($event)"
        >
          <mat-option
            *ngFor="let option of expiryOptions; trackBy: trackByValue"
            [value]="option.value"
          >
            {{ option.label }}
          </mat-option>
        </mat-select>
        <div class="field-hint">For reference only; it doesn't stop fleet washes.</div>
      </div>

      <!-- Payment Term -->
      <div class="form-field">
        <label class="field-label" id="fleet-payment-term-label"
          >Payment Term<span class="asterisk">*</span></label
        >
        <mat-select
          class="form-select"
          aria-labelledby="fleet-payment-term-label"
          [ngModel]="formData().paymentTermDays"
          (ngModelChange)="onPaymentTermChange($event)"
        >
          <mat-option
            *ngFor="let option of paymentTermOptions; trackBy: trackByValue"
            [value]="option.value"
          >
            {{ option.label }}
          </mat-option>
        </mat-select>
        <div class="field-hint">
          The payment due period, starting from the date the invoice is issued.
        </div>
      </div>

      <!-- Avg. Washes/Month -->
      <div class="form-field">
        <label class="field-label">Average Washes/Month</label>
        <div class="input-wrapper">
          <input
            type="number"
            class="form-input"
            [class.error]="formData().avgWashesPerMonth === 0 || avgWashesError()"
            placeholder="Enter avg. washes/month"
            min="0"
            max="100"
            [value]="formData().avgWashesPerMonth"
            (input)="onAvgWashesInput($event)"
            (keydown)="onAvgWashesKeydown($event)"
          />
          <div *ngIf="formData().avgWashesPerMonth === 0 || avgWashesError()" class="field-error">
            {{ avgWashesError() || 'Average washes must be greater than 0' }}
          </div>
        </div>
      </div>

      <!-- Receive Notifications for Billing Reminder -->
      <div class="form-field">
        <label class="field-label">Receive Notifications for Billing Reminder</label>
        <div class="input-wrapper">
          <input
            type="text"
            class="form-input"
            placeholder="ops@business.com, billing@business.com"
            [value]="formData().notificationRecipients"
            (input)="onNotificationRecipientsInput($event)"
          />
        </div>
      </div>

      <div class="form-field-spacer"></div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <div class="footer-content">
        <button class="btn btn-secondary" (click)="onClose()">Cancel</button>
        <button
          class="btn btn-primary"
          [class.disabled]="!isFormValid() || creatingFleet()"
          [disabled]="!isFormValid() || creatingFleet()"
          (click)="onSave()"
        >
          <span *ngIf="creatingFleet()">{{ isEditMode ? 'Updating...' : 'Creating...' }}</span>
          <span *ngIf="!creatingFleet()">{{ isEditMode ? 'Update' : 'Create Fleet' }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
